import { Box, Typography } from '@mui/material';
import Lottie from 'lottie-react';
import successLottie from './../../../utils/Lottie/NewSuccess.json';
import { CustomButton } from '../../../v2/MUI_custom_component';

const SuccessScreen = ({
  title = "Successful!",
  subtitle = "Operation completed successfully.",
  filledButtonLabel,
  filledButtonAction,
  OutlinedButtonLabel,
  OutlinedButtonAction,
  height = '80vh',
}) => {

  return (
    <Box
      sx={{
        textAlign: 'center',
        padding: 4,
        backgroundImage: `url(https://d2djimvzddgguw.cloudfront.net/humbee-inventory/pattern_bg.svg)`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: 'auto',
      }}
    >
      <Box
        sx={{
          mt: 4,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height,
        }}
      >
        <Lottie
            animationData={successLottie}
            loop={true}
            style={{ width: 150, height: 150, marginBottom: 20 }}
        />

        <Typography variant="h2">{title}</Typography>

        {subtitle && (
          <Typography
            variant="body1"
            sx={{ textAlign: 'center', marginBottom: 5 }}
          >
            {subtitle}
          </Typography>
        )}
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          alignItems: 'center',
          width: { md: '20%' }
        }}>

        {filledButtonLabel && filledButtonAction && (
          <CustomButton
            variant="filled"
            color="primary"
            label={filledButtonLabel}
            onClick={filledButtonAction}
            sx={{ width: { xs: '100%', sm: '100%%' } }}
          />
        )}
        {OutlinedButtonLabel && OutlinedButtonAction && (
          <CustomButton
            variant="outlined"
            color="primary"
            label={OutlinedButtonLabel}
            onClick={OutlinedButtonAction}
            sx={{ width: { xs: '100%',  sm: '100%' }}}
          />
        )}
        </Box>
      </Box>
    </Box>
  );
};

export default SuccessScreen;
